
import React from 'react';
import { MessageCircle } from 'lucide-react';

const FloatingWhatsApp = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/306986904312', '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white px-4 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 flex items-center gap-2"
      aria-label="Contact via WhatsApp"
    >
      <MessageCircle size={20} />
      <span className="text-sm font-medium">WhatsApp</span>
    </button>
  );
};

export default FloatingWhatsApp;
